import * as dat from 'dat.gui';

const gui = new dat.GUI();

export default gui;
